<template>
	<el-dialog v-model="innerVisible"  :close-on-click-modal="false" :title="title" width="92%"  custom-class="zero-padding-modal" @open="openInit" @opened="openedInit" @closed="closeDeal">
		<template #default>			
			<div class="assemble-edit-modal-content">
				<el-form :model="addForm" label-width="130px" ref="dialogRef" :rules="formRules" style="margin:20px 20px 0 0;margin-top: 20px;" >
					<el-row>
						<!-- <el-col :span="6">
							<el-form-item label="调拨单别:" prop="orderCategory">
								<el-select v-model="addForm.orderCategory" clearable allow-create filterable placeholder="请选择调拨单别" size="large" style="width: 100%;" >
									<el-option v-for="item in CMSMQData" :key="item.label" :label="item.mQ002" :value="item.mQ001" />
								</el-select>
							</el-form-item>
						</el-col> -->
						<el-col :span="4">
							<el-form-item label="部门编号:" prop="departmentNumber">
								<!-- <el-input v-model="query.departmentNumber" clearable placeholder="请输入部门编号" /> -->
								<el-select v-model="addForm.departmentNumber" clearable allow-create filterable placeholder="请选择部门编号" size="large" style="width: 100%;">
									<el-option v-for="item in departmentData" :key="item.label" :label="item.mE002" :value="item.mE001" />
								</el-select>
							</el-form-item>
						</el-col> 
						<el-col :span="4">
							<el-form-item label="项目编号:" prop="projectCode">
								<!-- <el-input v-model="addForm.projectCode" clearable placeholder="请输入项目编号" /> -->
								<el-select
									style="width: 100%;"
									v-model="addForm.projectCode"							
									filterable
									remote
									reserve-keyword
									placeholder="请输入项目编号"
									remote-show-suffix
									:remote-method="projectRemoteMethod"
									:loading="projectloading"
								>
									<el-option
									v-for="(item,index) in projectOptions"
									:key="index"
									:label="item"
									:value="item"
									/>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="4">
							<el-form-item label="备注:" prop="remarks">
								<el-input v-model="addForm.remarks" clearable placeholder="请输入备注" />
							</el-form-item>
						</el-col>  
						<el-col :span="6">
							<div style="margin-left: 20px;"><el-button type="primary" icon="el-icon-plus" @click="onOpenChooseModal">添加物料</el-button></div>	
						</el-col> 
						<el-col :span="6">
							<div style="display: flex;">
						<el-select
							style="width: 100%;"
							v-model="transferredILocation"							
							filterable
							remote
							reserve-keyword
							placeholder="请输入转入库位"
							remote-show-suffix
							:remote-method="remoteMethod"
							:loading="loading"
						>
							<el-option
							v-for="(item,index) in options"
							:key="index"
							:label="item"
							:value="item"
							/>
						</el-select>
						<div><el-button type="primary" icon="el-icon-plus" @click="onSameLocal">同步库位</el-button></div>	           
						
					</div>
						</el-col>                                
					</el-row>
				</el-form>
				<!-- <div class="modal-content-top" style="display: flex;justify-content: space-between;">
					<div style="display: flex;">
						<div><el-button type="primary" icon="el-icon-plus" @click="onOpenChooseModal">添加物料</el-button></div>	           
					
					</div>
					<div style="display: flex;">
						<el-select
							style="width: 100%;"
							v-model="transferredILocation"							
							filterable
							remote
							reserve-keyword
							placeholder="请输入转入库位"
							remote-show-suffix
							:remote-method="remoteMethod"
							:loading="loading"
						>
							<el-option
							v-for="(item,index) in options"
							:key="index"
							:label="item"
							:value="item"
							/>
						</el-select>
						<div><el-button type="primary" icon="el-icon-plus" @click="onSameLocal">同步库位</el-button></div>	           
						
					</div>
					
				</div>	 -->
				<div class="modal-content-list">
					<div class="list-padding">
						<el-table :data="list" border row-key="tableKey" height="630">
							<el-table-column label="序号" align="center" width="60">
								<template #default="scope">{{scope.$index+1}}</template>
							</el-table-column>
							<el-table-column label="项目编号" prop="projectCode" align="center" width=""/>
							<el-table-column label="品号" prop="code" align="center" width="" :sortable="true"/>
							<el-table-column label="品名" prop="name" align="center" width="250"/>
							<el-table-column label="规格型号" prop="specificationModel" align="center" width="350"/>
							<el-table-column label="单位" prop="unit" align="center" width="60"/>							
							<el-table-column label="容器编号" prop="containerCode" align="center" width=""/>
							<el-table-column label="库位编号" prop="locationCode" align="center" width=""/>
							<el-table-column label="库位状态" align="center" width="">
							  <template #default="scope">
							    <span>{{ localStatus(scope.row.locationStatus) }}</span>
							  </template>
							</el-table-column>
							<el-table-column label="库存数" prop="currentQuantity" align="center" width=""/>
							<el-table-column label="出库数" width="" align="center">
							  <template #default="scope">
									<el-input-number v-model="scope.row.orderQuantity" :min="0" :max="scope.row.currentQuantity" size="small" />
							  </template>
							</el-table-column>
							<el-table-column label="转入库位" width="" align="center">
							  <template #default="scope">
									<el-input v-model="scope.row.transferredILocation"   size="small" />
							  </template>
							</el-table-column>
							<!-- <el-table-column label="转入库位" prop="transferredILocation" align="center" width=""/> -->
							<!-- <el-table-column label="转入库位" width="" align="center">
							  <template #default="scope">
								<el-select
									style="width: 100%;"
									v-model="scope.row.transferredILocation"							
									filterable
									remote
									reserve-keyword
									placeholder="请输入转入库位"
									remote-show-suffix
									:remote-method="remoteMethods"
									:loading="loading"
								>
									<el-option
										v-for="(item,index) in options"
										:key="index"
										:label="item"
										:value="item"
									/>
								</el-select>
							  </template>
							</el-table-column>							 -->
							<el-table-column label="操作" width="80" align="center">
							  <template #default="scope">
							    <el-button type="danger" size="small" @click="onDel(scope.$index)">删除</el-button>
							  </template>
							</el-table-column>
						</el-table>
					</div>
				</div>				
			</div>			
			<!-- v-model:visible="chooseVisieble" -->
			<choose-material-modal ref="chooseVisies" :projectCode="addForm.projectCode" :chooseList="list" @callback="chooseModalCallback"  />
		</template>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="onBtnClose">取 消</el-button>
				<el-button type="primary" :disabled="list.length===0" @click="confirm">提 交</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script setup>
import { defineEmits, ref, computed,watch, toRefs,reactive,nextTick } from 'vue'	
import ChooseMaterialModal from './ChooseMaterialModal.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { AddTransdepartment,GetCMSMQ,GetLocationCode,GetProjectCode,AddBlackTransferOrderDetails,InsertBlackTransferOrder,TransferOrderDetails } from '@/service/main/invoices/allocateOrder';
import { localStatus } from '../../switchCase'
import ElUpload from "element-plus/lib/el-upload";
const emits = defineEmits(['update:visible','loadInitData','callback'])
import { exportExcel } from "@/utils/exportExcel";
const props = defineProps({
	visible:{
		type:Boolean,
		default:false
	},
	editDetails:{
		type:Array,
		default:()=>{
			return []
		}
	},
	mainEdit:{
		type:Object,
		default:()=>{
			return {}
		}
	},	
	type:{
		type:String,
		default:'info'
	},
	orderId:{
		type:[String,Number],
		default:''
	}
})
//////////////////////////////////
const formRules = {
    // orderCategory: [{ required: true, message: "发货地不能为空", trigger: "blur" }],
    departmentNumber: [{ required: true, message: "收货地址不能为空", trigger: "blur" }],
    projectCode: [{ required: true, message: "预计到达日期不能为空", trigger: "blur" }],
    // remarks: [{ required: true, message: "发货日期不能为空", trigger: "blur" }],
}
// 编辑送货预约窗口中表单数据绑定
const addForm = ref({
    id: 0,
	orderCategory:"",//单别
    departmentNumber: "",//部门编号
    projectCode: "",//项目编号
    remarks: "",
})
const departmentData = ref([])
const getStatusOption = function(){
	AddTransdepartment().then((d)=>{
		departmentData.value = d.data || []
	}).catch((err)=>{
		console.log(err)
	})
}
getStatusOption()
const CMSMQData = ref([])
const getStatusOptions = function(){
	GetCMSMQ().then((d)=>{
		CMSMQData.value = d.data || []
	}).catch((err)=>{
		console.log(err)
	})
}
getStatusOptions()
const { visible, type, orderId,editDetails,mainEdit } = toRefs(props)

const innerVisible = ref(false)
const title = ref('')
const chooseVisieble = ref(false)
const list = ref([])

watch(
	visible,
	function(newVal){
		if (innerVisible.value!==newVal) {
			innerVisible.value = newVal
		}
	},
	{immediate:true}
)
watch(innerVisible,function(newVal){
	if (visible.value!==newVal) {
		emits('update:visible',newVal)
	}
})

const closeDeal = function(){
	selfClose()
}

const onBtnClose = function(){
	selfClose()
}

const selfClose = function(){
	innerVisible.value = false
	addForm.value.orderCategory= ""//项目编号
    addForm.value.departmentNumber = ""
    addForm.value.projectCode = ""
    addForm.value.remarks = ""
	addForm.value = {}
	list.value = []
}

const checkBeforeSubmit = function() {
	let n = -1
	for (let i=0;i<list.value.length;i++) {
		if (list.value[i].orderQuantity<=0) {
			n = i;
			break
		}
	} 
	if (n===-1) {
		return true
	} else {
		ElMessageBox.alert(`第${n+1}笔物料出库数错误。`,'系统提示')
		return false
	}
}
const dialogRef = ref()
const confirm = function(){
	dialogRef.value.validate((valid) => {
        if (valid) {
            let f = checkBeforeSubmit()
			if (!f) return flase		
			addForm.value.transferOrderDetailsList = list.value
			console.log('addForm',addForm.value)
			if (type.value==='modify') {
				AddBlackTransferOrderDetails(addForm.value).then((res) => {
						ElMessage.success("操作成功")
						selfClose()
						emits('callback')
					}).catch(()=>{
						// callback && callback(false)
					})
				} else {
					InsertBlackTransferOrder(addForm.value).then((res) => {
						ElMessage.success("操作成功")
						selfClose()
						emits('callback')
					}).catch(()=>{
						// callback && callback(false)
					})
				}
			
        } 
    })
	
}
const openedInit = function(){	
	list.value = []	
	nextTick(() => {
		title.value = type.value==='modify' ? '修改单据' : '新增单据';
		if ( type.value==='modify') {
			TransferOrderDetails({id:mainEdit.value.id}).then((res) => {
				console.log('res',res)
				list.value = res.data.wareTransferOrderDetails.rows
				addForm.value = res.data
			}).catch(()=>{
				// callback && callback(false)
			})			
			// addForm.value = JSON.parse(JSON.stringify(mainEdit.value));
		}
	});
	// console.log('editDetails.value',editDetails.value)
	// console.log('list.value',list.value)
	// console.log('addForm.value',addForm.value)
}
const openInit = function(){
	// setTitle()
}
const setTitle = function(){
	if (type.value==='modify') {
		title.value = '修改单据'
	} else {
		title.value = '新增单据'
	}
}
const getModifyInitData = function(){
	emits('loadInitData',{id:orderId.value,PageNo:1,PageSize:9999},function(f,d){
		if (f) {
			list.value = (d.data.rows || []).map((obj,index)=>{
				obj.tableKey = 'edit-' + new Date().getTime() + '-' + index
				return obj
			})
		}
	})
}
const chooseVisies = ref()
const onOpenChooseModal = function(){
	// chooseVisieble.value = true
	chooseVisies.value.onQuery()
}

const chooseModalCallback = function(arr,cancelGwcIds){
	if (list.value.length===0) {
		list.value = arr.map((obj,index)=>{
			obj.tableKey = 'add-' + new Date().getTime() + '-' + index
			// obj.orderQuantity = obj.outNum
			obj.orderQuantity = obj.currentQuantity
			return obj
		})
	} else {
		addChooseMaterials(arr,cancelGwcIds)
	}
}

const addChooseMaterials = function(arr,cancelGwcIds) {
	let c = 0
	arr.forEach((arritem,arri)=>{
		if (checkMaterialExist(arritem)) {
			c++
		} else {
			arritem.tableKey = 'add-' + new Date().getTime() + '-' + arri
			arritem.orderQuantity = arritem.outNum
			list.value.push(arritem)
		}
	})
	//============ ly复选框记忆功能添加 :物料弹框中，用户手动取消的物料=======
	if (cancelGwcIds && cancelGwcIds.length > 0) {
		list.value = list.value.filter(item => {
			return !cancelGwcIds.includes(item.id);
		});
	}
	//============ ly复选框记忆功能添加=======
	// if (c>0) {
	// 	ElMessageBox.alert(`有${c}个物料已存在，未加入。`,'系统提示')
	// }
}

const checkMaterialExist = function(obj) {
	let res = false
	for (let i=0;i<list.value.length;i++) {
		if (list.value[i].code===obj.code && list.value[i].locationCode===obj.locationCode) {
			res = true
			break
		}
	}
	return res
}

const onDel = function(index) {
	list.value.splice(index,1)
}

//项目号模糊查询
const projectloading = ref(false)
const projectOptions = ref([])
const projectRemoteMethod = function(query){
	projectOptions.value = []
	if (query!==null&&query!==undefined&&query.length>2) {
		projectloading.value = true	
		GetProjectCode({ProjectCode:query}).then((res) => {
			// console.log('res',res)
			projectloading.value = false
			projectOptions.value = res.data
		}).catch(()=>{
			projectloading.value = false
		})
	} else {
		projectOptions.value = []
	}
}
//转入库位模糊查询
const loading = ref(false)
const options = ref([])
const remoteMethod = function(query){
	options.value = []
	if (query.length>2) {
		loading.value = true	
		GetLocationCode({LocationCode:query}).then((res) => {
			// console.log('res',res)
			loading.value = false
			options.value = res.data
		}).catch(()=>{
			loading.value = false
		})
	} else {
		options.value = []
	}
}
//转入库位
const remoteMethods = function(query){
	options.value = []
	if (query.length>2) {
		loading.value = true	
		GetLocationCode({LocationCode:query}).then((res) => {
			// console.log('res',res)
			loading.value = false
			options.value = res.data
		}).catch(()=>{
			loading.value = false
		})
	} else {
		options.value = []
	}
}
//导入
import local from '@/utils/cache'
import {useStore} from '@/store'
// const props = defineProps<{apiUrl: string}>();
const actionUrl = computed(() => local.getCache('host')=='192.168.150.23'?'http://192.168.150.23:9085/api/TransferOrder/ImportMaterial':'http://222.71.245.114:9085/api/TransferOrder/ImportMaterial')
const store = useStore();
const token = computed(() => store.state.login.token)

const headerObj = ref({
  Authorization: `Bearer ${token.value}`
});
// const uploadRef = ref<InstanceType<typeof ElUpload>>();
const uploadRef = ref();
const fileList = ref([]);
const submitUpload = () => {
  	// uploadRef.value!.submit();
	  uploadRef.value.submit()
};
const handleRemove = (file, fileList) => {
  // console.log('移除成功')
};
const handleSuccess = (response, file) => {
	console.log('fileList',fileList)
  if(response.code == 200) {
    console.log('response',response)
	response.data.forEach(item=>{
		item.orderQuantity = item.currentQuantity
		list.value.push(item)
	})
    
  }else {
    ElMessage.error(`导入失败${response.code}:${response.message}`)
  }

};
//
const modelList = ref([
	{code:'2200131272',projectCode:'AT22021',locationCode:'L02',currentQuantity:1},
	{code:'2200131228',projectCode:'AT22021',locationCode:'L02',currentQuantity:2}
])
//导出确认按钮
const localExport = () => {
		let entozh = {
			code: "品号",
			projectCode: "项目编号",
			locationCode: '库位编号',
			currentQuantity: '数量'
		};
		exportExcel(modelList.value, entozh, "xlsx", "导出模板");
	}
//同步库位
const transferredILocation = ref('')
const onSameLocal = () => {
	list.value.forEach(item=>{
		item.transferredILocation = transferredILocation.value
	})
}
</script>

<style lang="less" scoped>
.assemble-edit-modal-content{
	height: 80vh;
	display: flex;
	flex-direction: column;
	.modal-content-top {
		padding: 0 16px 16px 16px ;
		flex-shrink: 0;
	}
	.modal-content-list{
		flex-grow: 1;
		height: 1px;
		overflow: auto;
		.list-padding{
			padding: 0 16px;
		}
	}
}
</style>